module.exports = __webpack_public_path__ + "img/sc.7bf75adc.png";